import { Component, OnInit } from '@angular/core';
import {FaqService} from '../faq.service';
import {ToastrService} from 'ngx-toastr';
import {ActivatedRoute, Router} from '@angular/router';
import {Store} from '../../store';
import {OverlayService} from '../../services/overlay.service';
import {MenuService} from '../../services/menu.service';

@Component({
  selector: 'app-faq-questions',
  templateUrl: './faq-questions.component.html',
  styleUrls: ['./faq-questions.component.scss']
})
export class FaqQuestionsComponent implements OnInit {

    topic;
    topicId = '';
    question;
    toSave = [];

    confirmationData = {
        open: false,
        buttonText: 'Confirm',
        title: '',
        detail: '',
        data: undefined,
    };

    overlays$ = this.store.select<any>('overlays');

  constructor(
      private overlayService: OverlayService,
      private faqService: FaqService,
      private toastrService: ToastrService,
      private store: Store,
      private router: Router,
      private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
      if (this.route.snapshot.params.topic) {
          this.topicId = this.route.snapshot.params.topic;
          this.findOne();
      }
  }

  findOne() {
      this.faqService.findOne(this.topicId).subscribe(data => {
          this.topic = data.data;
      });
  }

  toggleStatus(question) {
      if (question.status) {
          question.status = false;
      } else {
          question.status = true;
      }
      this.faqService.updateQuestion(question).subscribe();
  }

    addQuestion() {
        this.question = undefined;
        this.overlayService.toggle('faqQuestion');
    }

    editQuestion(question) {
      this.question = question;
      this.overlayService.toggle('faqQuestion');
  }

  closeAction(e) {
      if (e.reload) {
          this.findOne();
      }
  }

    drop(e) {
        this.toSave = e;
        this.faqService.sortQuestions(this.toSave).subscribe(data => {
        });
    }

    deleteConfirm(question) {
        this.confirmationData.title = 'Please confirm you would like to delete this question';
        this.confirmationData.data = {};
        this.confirmationData.detail = '';
        this.confirmationData.open = true;
        this.question = question;
    }

    confirmAction(e) {
        if (e.action) {
            this.question.deleted = 1;
            this.faqService.updateQuestion(this.question).subscribe(data => {
                this.toastrService.success('Question deleted');
                this.findOne();
            });
        }
        this.confirmationData.open = false;
    }

    togglePopular(q) {
      if (!q.popular) {
          q.popular = true;
      } else {
          q.popular = false;
      }
      this.faqService.updateQuestion(q).subscribe();
    }

}
